export enum pageMetaTypes {
  session='session',
  // eslint-disable-next-line sonarjs/future-reserved-words
  public='public',
  // eslint-disable-next-line sonarjs/future-reserved-words
  private='private', // if a page doesn't hvae defined is type, by default is private
}
